import { useOutletContext } from "react-router-dom";
import ConversationTable from "admin/components/ConversationTable";
import { Agent } from "~/services/agents";

export const AgentConversationsTab = () => {
  const agent = useOutletContext<Agent>();
  return (
    <div className="flex h-full flex-col gap-4">
      <h2 className="text-2xl font-semibold">Conversations</h2>
      <ConversationTable lockedAgentId={agent.id} />
    </div>
  );
};
